export default "__VITE_ASSET__C_Gr_vU5__"